import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { mapProps } from 'recompose';
import { prop, compose } from 'ramda';

import connect from 'app/libs/connect';
import Styled from 'app/features/couponCampaign/landing/components/HeroBlock.styled';
import CouponProductCta from 'app/features/couponCampaign/landing/components/CouponProductCta';
import Heading from 'app/components/layout/Heading.styled';
import Perks from 'app/features/couponCampaign/landing/components/Perks';
import RenewalNotice from 'app/features/couponCampaign/landing/components/RenewalNotice';
import Text from 'app/components/layout/Text.styled';
import { heroBlockProps } from 'app/features/couponCampaign/landing/selectors';
import BasicLink from 'app/components/Links/BasicLink.styled';

const UI = ({
  imageUrl,
  imageUrl2X,
  titleKey,
  subTitleKey,
  legalCopyKey,
  tosLink,
}) => (
  <Styled.HeroBlock>
    <Styled.ImageWrapper>
      <Styled.Image src={imageUrl} srcSet={imageUrl2X} alt="background" />
    </Styled.ImageWrapper>
    <Styled.UpsellWrapper>
      <Styled.Logo
        src={`${window.etp.config.assetsUrl}img/coupon_campaign/logo.png`}
        srcSet={`${window.etp.config.assetsUrl}img/coupon_campaign/logo@2x.png 2x`}
        alt="Coupon Campaign"
      />
      <Heading size="l" as={Styled.Title}>
        <FormattedMessage id={titleKey} />
      </Heading>
      <Text size="l" as={Styled.SubTitle}>
        <FormattedMessage id={subTitleKey} />
      </Text>
      <Styled.ButtonHolder>
        <CouponProductCta />
      </Styled.ButtonHolder>
      <RenewalNotice />
      <Perks />
      <Text size="l" as={Styled.PromotionRequirements}>
        <FormattedMessage
          id={legalCopyKey}
          values={{
            tosLink: (
              <BasicLink
                testId="terms-of-service-link"
                href={tosLink}
                target="_blank"
              >
                <FormattedMessage id="coupon_landing_promotion_tos_link" />
              </BasicLink>
            ),
          }}
        />
      </Text>
    </Styled.UpsellWrapper>
  </Styled.HeroBlock>
);

UI.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageUrl2X: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  subTitleKey: PropTypes.string.isRequired,
  legalCopyKey: PropTypes.string.isRequired,
  tosLink: PropTypes.string.isRequired,
};

UI.displayName = 'CouponCampaign HeroBlock';

const HeroBlock = compose(
  connect({ heroBlockProps }),
  mapProps(prop('heroBlockProps')),
)(UI);

export { UI };

export default HeroBlock;
